import { MediaType as MimeType, mediaTypeEqual } from "@redotech/media-type";
import { ImageType } from "@redotech/media-type/image";

const IMAGE_HEIC = ImageType.subtype("heic");
const IMAGE_HEIF = ImageType.subtype("heif");

export const MediaType = {
  Image: "image",
  Audio: "audio",
  Video: "video",
  Pdf: "pdf",
  Zip: "zip",
  Text: "text",
  Other: "other",
} as const;

export type MediaType = (typeof MediaType)[keyof typeof MediaType];

export function getMediaType(
  url: string,
  mimeType: string | null | undefined,
): MediaType {
  if (mimeType?.startsWith("image/") || isHeicUrl(url)) {
    return MediaType.Image;
  }
  if (mimeType?.startsWith("audio/")) {
    return MediaType.Audio;
  }
  if (mimeType?.startsWith("video/")) {
    return MediaType.Video;
  }
  if (mimeType === "application/pdf") {
    return MediaType.Pdf;
  }
  if (mimeType === "application/zip") {
    return MediaType.Zip;
  }
  if (mimeType === "text/plain") {
    return MediaType.Text;
  }
  return MediaType.Other;
}

export function isMediaType(
  url: string,
  mimeType: string | null | undefined,
  type: MediaType,
): boolean {
  return getMediaType(url, mimeType) === type;
}

export function isHeicImage(
  url: string,
  mimeType: string | null | undefined,
): boolean {
  return (
    (mimeType && isHeicMimeType(MimeType.parse(mimeType))) || isHeicUrl(url)
  );
}

function urlHasExtension(url: URL, extension: string): boolean {
  return url.pathname.endsWith(`.${extension}`);
}

function isHeicMimeType(mediaType: MimeType): boolean {
  return (
    mediaTypeEqual(mediaType, IMAGE_HEIC) ||
    mediaTypeEqual(mediaType, IMAGE_HEIF)
  );
}

function isHeicUrl(url: string): boolean {
  const u = new URL(url);
  return urlHasExtension(u, "heic") || urlHasExtension(u, "heif");
}
